import React, { useState, useEffect, useRef } from "react";
import {
    Spinner
} from "reactstrap";

const TradeGrandTotal = ({ ...props }) => {
    const [totall, setTotal] = useState([]);
    const [load, setload] = useState(true)
    const Total = async () => {
        const sendData = {
            UserId: Number(props.UserId),
            YearId: Number(props.year),
            ToYearId: Number(props.toyear),
            ToMonthId: Number(props.tomonth),
            MonthId: Number(props.Month)
        }

        await fetch(process.env.REACT_APP_API_LINK + 'api/NCSCDA/Reporttotaltrade', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    if (data.length > 0) {
                        setTotal(data[0])
                    } else {
                        setTotal([])
                    }
                    setload(false)
                })

    };



    useEffect(() => {
        setload(true)
        Total()
    }, [props.UserId, props.generate])
    
  
    return (
        <>
            {load ? <Spinner color="success" /> : 
                <>
                    
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                        {totall.genderMale4 >= 0 ? totall.genderMale4:0}
                    </td>

                </>
           
        }</>
    );
};

export default TradeGrandTotal;
